import { render, staticRenderFns } from "./attrValueList.vue?vue&type=template&id=78b466b9&scoped=true"
import script from "./attrValueList.vue?vue&type=script&lang=js"
export * from "./attrValueList.vue?vue&type=script&lang=js"
import style0 from "./attrValueList.vue?vue&type=style&index=0&id=78b466b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b466b9",
  null
  
)

export default component.exports